import * as React from 'react';
import { HashRouter , Route, Link, Routes  } from 'react-router-dom'
import Coin from './Coin'
import Dice from './Dice'
import Multiple from './Multiple'

import TextField from '@mui/material/TextField'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import MailIcon from '@mui/icons-material/Mail'
import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'

import { ThemeProvider } from '@mui/material/styles'
import { createTheme } from '@mui/material/styles'
import Brightness3Icon from '@material-ui/icons/Brightness3'
import Brightness7Icon from '@material-ui/icons/Brightness7'

import CssBaseline from '@mui/material/CssBaseline';

import Container from '@mui/material/Container';

const iOS =
  typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

function App(props) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
  const [theme, setTheme] = React.useState(!darkThemeMq.matches)
  const icon = !theme ? <Brightness7Icon /> : <Brightness3Icon /> // Icons imported from `@material-ui/icons`
  const appliedTheme = createTheme(theme ? light : dark)

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  function appbar() {
    return (
      <Box sx={{ flexGrow: 1}}>
        <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer('bottom', true)}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
              <BasicMenu />
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="mode"
              onClick={() => setTheme(!theme)}>
              {icon}
            </IconButton>
          </Toolbar>
        </AppBar>
      </Box>
    )
  }

  const listitem = [
    { name: 'Coin', path: '/', icon: null },
    { name: 'Multiple', path: '/mc', icon: null },
    { name: 'Dice', path: '/dice', icon: null },
  ]
  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer('bottom', false)}
      onKeyDown={toggleDrawer('bottom', false)}>
      <List>
        {listitem.map((item, index) => (
          <nav key={item}>
          <Link to={item.path} style={{ all: 'unset' }}>
            <ListItem button key={item.name}>
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItem>
          </Link>
          </nav>
        ))}
      </List>
      <Divider />
    </Box>
  )

  return (
    <div>
      <ThemeProvider theme={appliedTheme}>
        <React.Fragment>
        <HashRouter>
        <Container sx={{ maxWidth:'1000px'  }} maxWidth={false}>
          {appbar()}
          
          
            <Routes>
            <Route exact path="/" element={<Coin />} />
            <Route  path="/dice/" element={<Dice />} />
            <Route  path="/mc/" element={<Multiple />} />
            </Routes>
          
          <CssBaseline />
          </Container>
          <SwipeableDrawer
            anchor={'bottom'}
            open={state['bottom']}
            onClose={toggleDrawer('bottom', false)}
            onOpen={toggleDrawer('bottom', true)}>
            {list()}
          </SwipeableDrawer>
          </HashRouter>
        </React.Fragment>
      </ThemeProvider>
    </div>
  )
}

export const light = {
  palette: {
    mode: 'light',
    
  },
}
export const dark = {
  palette: {
    mode: 'dark',
    text: {
      primary: '#FFFFFF',
    },
  }, 
  components: {
    // Name of the component
    MuiInputBase: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          color: '#FFFFFF',
        },
      },
    }, 
  },
}


export function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
    </div>
  );
}


export default (App)
